import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { init, ErrorBoundary } from "@sentry/react";

import { MainPageFallback } from "components/error";
import { router } from "routes/router";

import "@fontsource-variable/inter";
import "./index.css";

init({
  dsn: import.meta.env.SENTRY_DSN as string,
  environment: import.meta.env.LH_ENV_NAME as string,
  ignoreErrors: ["AbortError"],
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary fallback={MainPageFallback}>
      <RouterProvider
        router={router}
        future={{
          v7_startTransition: true,
        }}
      />
    </ErrorBoundary>
  </React.StrictMode>,
);
